
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  leadAdsEditorIframeSource,
  LeadAdsEditorIframePayloadType,
  LeadAdsMobileEditorType
} from '@/const/leadAds'

@Component({
  name: 'LeadFormEditorIframe'
})
export default class LeadFormEditorIframe extends Vue {
  @Prop({ default: '', type: String })
  readonly iframeSrc!: string
  @Prop({ default: '', type: String })
  readonly type!: LeadAdsMobileEditorType

  $refs: {
    editorIframeRef: HTMLIFrameElement;
  }

  iframeLoading = true
  @Watch('iframeSrc', { immediate: true })
  onIframeSrcChange(newVal: string) {
    if (newVal) {
      this.iframeLoading = true
      this.$nextTick(() => {
        this.setupEditorIframe()
      })
    } else {
      this.resetEditorIframe()
    }
  }

  editorIframeMessageHandler(event: MessageEvent) {
    if (event.origin !== location.origin) return
    const { source = '', payload = {} } = event.data || {}
    if (source !== leadAdsEditorIframeSource) return
    if (payload.type === LeadAdsEditorIframePayloadType.FINISH) {
      this.$emit('finish')
      if (this.type === LeadAdsMobileEditorType.create) {
        this.$trackEvent('adp_waplite_click', {
          fastcr_creative_upload: 'instant_page_mobile_editor_create_form_success'
        })
      }
    } else if (payload.type === LeadAdsEditorIframePayloadType.CANCEL) {
      this.$emit('cancel')
      if (this.type === LeadAdsMobileEditorType.create) {
        this.$trackEvent('adp_waplite_click', {
          fastcr_creative_upload: 'instant_page_mobile_editor_create_form_cancel'
        })
      }
    }
  }

  setupEditorIframe() {
    this.$refs.editorIframeRef?.addEventListener('load', () => {
      this.iframeLoading = false
    })
    window.addEventListener('message', this.editorIframeMessageHandler)
  }

  resetEditorIframe() {
    window.removeEventListener('message', this.editorIframeMessageHandler)
  }
}
